export default {
  common: {
    Unsaved_changes: 'Nicht gespeicherte Änderungen',
    There_are_unsaved_changes_in_this_comment: 'Dieser Kommentar enthält nicht gespeicherte Änderungen.',
    Continue_editing: 'Weiter bearbeiten',
    Drop_changes: 'Änderungen verwerfen',
    Add_link: 'Link hinzufügen',
    Enter_a_URL: 'URL eingeben',
    Link_text: 'Text',
    Enter_link_text: 'Anzuzeigenden Text eingeben',
    Cancel: 'Abbrechen',
    Add: 'Hinzufügen',
    Executed_by_agent: 'Ausgeführt von {agent}',
    Save: 'Speichern',
    Edit: 'Bearbeiten',
    Update: 'Aktualisieren',
    Previous: 'Zurück',
    Next: 'Weiter',
    Loading: 'Wird geladen…',
    Total: 'Gesamt',
    Details: 'Details',
  },
  dayoff: {
    select_title: 'Wähle deine freien Tage',
    selection_hint: 'Tag anklicken · ziehen, um einen Zeitraum zu wählen',
    today: 'Heute',
    days_selected: 'Tag(e) ausgewählt',
    selected_days: 'Ausgewählte Tage',
    legend_selected: 'Ausgewählt',
    legend_your: 'Dein freier Tag',
    legend_holiday: 'Gesetzlicher Feiertag',
    legend_mate: 'Teammitglied abwesend',
    away_this_period: 'In diesem Zeitraum abwesend',
    nobody_away: 'In diesem Zeitraum ist niemand abwesend',
    description: 'Beschreibung',
    description_placeholder: 'z. B. Urlaub, voller Tag…',
    submit: 'Freie Tage speichern',
    saved: 'Freie Tage gespeichert: {range} — {count} Tag(e)',
    saved_empty: 'Alle freien Tage entfernt',
    you: 'du',
    tip_holiday: 'Feiertag',
    tip_away: 'Abwesend',
    tip_out_count: '1 Person ist abwesend | {count} Personen sind abwesend',
    tip_more: '+{count} weitere',
    days_count: '1 Tag | {count} Tage',
    tip_holiday_war: 'Während des Kriegsrechts kein freier Tag',
    on_dayoff_today: 'Heute freier Tag',
    gcal_title: 'Google Kalender',
    gcal_connect: 'Google Kalender verbinden',
    gcal_connected: 'Google Kalender synchronisiert',
    gcal_disconnect: 'Trennen',
    history_title: 'Verlauf',
    history_period: 'Zeitraum',
    history_days: 'Tage',
    history_note: 'Notiz',
    history_added: 'Hinzugefügt',
    history_empty: 'Du hast noch keine freien Tage genommen',
    history_requests: '1 Antrag | {count} Anträge',
    history_used_year: '1 Tag dieses Jahr genommen | {count} Tage dieses Jahr genommen',
    days_short: '{count} T.',
    unsaved_title: 'Ungespeicherte freie Tage',
    unsaved_message: 'Deine ausgewählten Tage und die Notiz sind noch nicht gespeichert.',
    unsaved_keep: 'Weiter bearbeiten',
    unsaved_drop: 'Änderungen verwerfen',
    clear: 'Auswahl löschen',
  },
  board: {
    add_new_task: 'Neue Aufgabe hinzufügen',
    add_stage: 'Phase hinzufügen',
    add_column: 'Spalte hinzufügen',
    enter_stage_name: 'Namen der Phase eingeben',
    no_stages_title: 'Noch keine Phasen',
    no_stages_text: 'Füge deine erste Phase hinzu, um Aufgaben zu erstellen.',
    need_stage_to_create_task: 'Füge diesem Projekt mindestens eine Phase hinzu, bevor du eine Aufgabe erstellst.',
    Enter_task_description: 'Aufgabenbeschreibung eingeben',
    Delete_stage: 'Phase löschen',
    sure_delete_stage: 'Möchtest du diese Phase wirklich löschen?',
    really_delete_stage: 'Möchtest du die Phase wirklich löschen',
    stage_also_leted: 'Alle Aufgaben in der Phase werden ebenfalls gelöscht!',
    CANCEL: 'ABBRECHEN',
    YES: 'JA',
    we_send_invite: 'Wir haben eine Einladung an folgende E-Mail gesendet:',
    please_ask_user: 'Bitte den Nutzer, den Link zu bestätigen, um deinem Projekt beizutreten',
    okay: 'Okay',
  },
  comments: {
    bot_line1: 'Gut gemacht. Du hast eine Aufgabe geöffnet!',
    bot_line2: 'Wie du siehst, wird deine Zeit unten rechts bereits gezählt',
    bot_line3:
      'Du kannst hier eine neue Nachricht schreiben oder eine Datei per Drag & Drop als Anhang hinzufügen',
    max_pins_reached: 'Maximal 5 angepinnte Kommentare erlaubt',
    pin_comment: 'Kommentar anpinnen',
    pinned_comments: 'Angepinnte Kommentare',
    add_reaction: 'Reaktion hinzufügen',
  },
  notifications: {
    all_caught_up: 'Du bist auf dem neuesten Stand',
    all_caught_up_hint: 'Erwähnungen, Einladungen und Anfragen erscheinen hier',
    read_all: 'Alle gelesen',
    added_you_to_project: 'hat dich zum Projekt hinzugefügt',
    open_project: 'Projekt öffnen',
    rejected_invite_workspace: 'hat die Einladung zu diesem Arbeitsbereich abgelehnt',
    requested_to_add: 'hat angefragt hinzuzufügen',
    for: 'für',
    Task: 'Aufgabe',
    task_created: 'erstellt',
    task_deleted: 'gelöscht',
    task_transferred: 'übertragen',
    task_restored: 'wiederhergestellt',
    Restore: 'Wiederherstellen',
    image_deleted: 'Bild gelöscht',
    NEW: 'NEU',
    Accept: 'Annehmen',
    Reject: 'Ablehnen',
    Accepted: 'Angenommen',
    Rejected: 'Abgelehnt',
    Viewed: 'Gesehen',
    Then_Deleted: 'Dann gelöscht',
    Then_Canceled: 'Dann abgebrochen von',
    by: 'von',
    notify_assigned: 'hat dich zugewiesen zu',
    mention_in_task: 'Erwähnung in',
    mentioned_you_in_task: 'hat dich in einer Aufgabe erwähnt',
    invoice_autogen_failed: 'Die Rechnung für {month} konnte nicht automatisch erstellt werden, Vorlage',
    invoice_autogen_sent: 'Die Rechnung für {month} wurde automatisch gesendet, Vorlage',
    open_invoice_generator: 'Rechnungsgenerator öffnen',
    to_a_task: 'zu einer Aufgabe',
    new_assign: 'Du wurdest einer Aufgabe zugewiesen',
    dayoff_is_off: '{name} ist nicht da',
    user_commented: '{name} hat kommentiert',
    user_assigned_you: '{name} hat dich zugewiesen',
    offline_mode: 'Offline-Modus',
    no_new_version_found: 'Keine neue Version gefunden',
    your_account_deleted: 'Dein Konto wurde gelöscht',
  },
  uploads: {
    not_uploaded: '{count} nicht hochgeladen',
    queued: 'In der Warteschlange',
    saving: 'Wird gespeichert',
    done: 'Fertig',
    retry_attempt: 'Wiederholung {attempt} von {max}',
    offline: 'Warte auf das Netzwerk',
    failed: 'Nicht hochgeladen',
    retry: 'Wiederholen',
    remove: 'Entfernen',
    errors: {
      too_large: 'Größer als {limit}, nicht hochgeladen',
      not_uploaded: 'Die Datei hat den Speicher nicht erreicht',
      storage_refused: 'Der Speicher hat die Datei abgelehnt',
      unreachable_storage: 'Speicher nicht erreichbar',
      server_error: 'Der Server konnte die Datei nicht speichern',
    },
  },
  system: {
    syncing: 'Synchronisierung',
    __resume_button: 'Fortsetzen',
    __ok_button: 'OK',
    __stop_button: 'Stopp',
    __hide_button: 'Ausblenden',
    __resume_last_task: 'Letzte Aufgabe fortsetzen',
    __create_task_notify: 'Aufgabe erstellen',
    __not_tracking_title: 'Du erfasst gerade nicht',
    __not_tracking_subtitle: 'seit 10 Minuten',
    __wait_install_app: 'Bitte warten. Tracklify wird installiert...',
    __accept_button: 'Annehmen',
    __reject_button: 'Ablehnen',
    __mute_tomorrow: 'Heute stummschalten',
    __muted_title: 'Erinnerungen stummgeschaltet',
    __muted_subtitle: 'bis morgen',
    __undo: 'Rückgängig',
    __timer_running: 'Timer läuft',
    __approve_tracked_time: 'Erfasste Zeit bestätigen',
    __no_estimate: 'Keine Schätzung',
    __not_tracking_label: 'Keine Erfassung',
    __until_tomorrow: 'Bis morgen',
    __no_activity_detected: 'Keine Aktivität erkannt',
    __open_app: 'App öffnen',
    __cancel: 'Abbrechen',
    __you_resume_tracking: 'Du hast die Zeiterfassung fortgesetzt für:',
    /* Main notify */
    __tracker_was_closed: 'Der Tracker wurde bei laufender Erfassung geschlossen',
    __tracking_resume: 'Zeiterfassung fortgesetzt',
    __new_version_found: 'Eine neue Version wurde gefunden',
    __new_version_found_but_error:
      'Eine neue Version wurde gefunden, aber automatische Updates werden auf diesem System nicht unterstützt',
    __new_version_download_button: 'Herunterladen',
    __later_button: 'Später',
    __downloading_version: 'Neue Version wird heruntergeladen',
    __install_button: 'Jetzt installieren',
    __downloading_version_percent: 'Neue Version wird heruntergeladen',
    __failed_download: 'Neue Version konnte nicht heruntergeladen werden',
    __try_again: 'Erneut versuchen',
    __dismiss_button: 'Verwerfen',
    __installing_new_version: 'Neue Version wird installiert',
    __failed_install: 'Neue Version konnte nicht installiert werden',
    __failed_open_new_version:
      'Neue Version konnte nicht geöffnet werden. Bitte schließe die Anwendung und öffne sie manuell erneut.',
    __close_app: 'App schließen',
    __tracking_stopped: 'Erfassung gestoppt: Inaktivität',
    __tricking_resume: 'Erfassung fortgesetzt: System aufgeweckt',
    __tracking_stopped_shutdown: 'Erfassung gestoppt: PC wird heruntergefahren',
    __tricking_resume_unlocked: 'Erfassung fortgesetzt: Bildschirm entsperrt',
    __downloading_done: 'Download abgeschlossen',
  },
  appRunner: {
    open_now: 'Jetzt öffnen',
    not_installed: 'Nicht installiert',
    started: 'Gestartet',
    starting: 'Wird gestartet',
    install_app_to_track: 'Desktop-App holen',
    instalattion_is_simple:
      'Vergiss „Bildschirm teilen“-Dialoge, erhalte schöne Benachrichtigungen und die beste Nutzererfahrung mit der Tracklify Desktop-App!',
    install_desktop: 'Installiere die Tracklify Desktop-App für unterbrechungsfreie Erfassung',
    authorize_app: 'Autorisiere deine Anwendung',
    click_to_authorize: 'Klicke auf „Jetzt öffnen“, um die App zu öffnen als',
    install_step1: 'Lade die App über die Schaltfläche unten herunter',
    install_step2: 'Führe die heruntergeladene Datei aus',
    see_other_platforms: 'Downloads für andere Plattformen ansehen',
    install_help: 'Installationshilfe',
    done_button: 'Fertig',
    already_installed: 'Bereits installiert? Sie können diese Seite schließen.',
    download_app: 'App herunterladen',
    download_app_deb: 'App für Ubuntu, Mint und andere Debian-basierte Systeme',
    download_app_rpm: 'App für Redhat, Fedora und andere RPM-basierte Systeme',
    download_app_pacman: 'App für Arch Linux und andere Arch-basierte Systeme',
    download_app_mac: 'macOS-App herunterladen (DMG)',
  },
  search: {
    search_or_navigate: 'Suchen oder navigieren',
    hint: 'Aufgabentext, Mitgliedsname,<br> Tag oder Projektname eingeben',
    nothing_found: 'Nichts gefunden ¯\\_(ツ)_/¯',
    go_to: 'Gehe zu',
    open: 'Öffnen',
    in: 'in',
    in_tasks: 'In Aufgaben suchen:',
    invite: 'Einladen',
    invite_to_project: 'zum Arbeitsbereich und Projekt',
    invite_user: 'Nutzer einladen',
    tasks_on: 'Aufgaben zu:',
    tasks_by: 'Aufgaben von:',
    unassigned: 'Nicht zugewiesen',
    noTag: 'Keine Tags',
    clear_all: 'Alle löschen',
    clear: 'Löschen',
    tagged: 'getaggt',
    show_all_tags: 'Alle Tags anzeigen',
    on: 'zu',
    by: 'von',
    sign_up_not_confirmed: 'Registrierung im Arbeitsbereich nicht bestätigt',
  },
  combobox: {
    nothing_found: 'Nichts gefunden',
    create_hint: 'Drücke Enter, um „{query}“ hinzuzufügen',
    clear: 'Löschen',
  },
  taskFilters: {
    filter: 'Filter',
    title: 'Filter',
    applyFilters: 'Filter anwenden',
    show_more: 'Mehr anzeigen',
    hide: 'Ausblenden',
    createdTime: 'Erstellungsdatum',
    today: 'Heute',
    yesterday: 'Gestern',
    assignee: 'Zugewiesen an',
    executor: 'Ausführender',
    createdBy: 'Erstellt von',
    tags: 'Tags',
    withTags: 'Mit Tags',
    avgUserVelocityPerDay: 'Durchschnittliche Nutzergeschwindigkeit pro Tag',
    userAlreadyTrackedTimeByTag: 'Bereits erfasste Zeit nach Tag',
    estimation: 'Schätzung',
    inTotal: 'Insgesamt:',
  },
  projectPriorities: {
    title: 'Projektreihenfolge',
    hint: 'Ziehe Projekte, um die Reihenfolge ihrer Aufgabengruppen in „Meine Aufgaben“ festzulegen. Dringende Aufgaben bleiben immer oben, Aufgaben mit niedriger Priorität unten.',
    empty: 'Noch in keinem Projekt Mitglied',
    archived: 'Archiviert',
  },
  taskHistory: {
    empty: 'Hier gibt es noch keine erfassten Aufgaben',
    empty_hint: 'Starten Sie einen Timer für eine Aufgabe oder ändern Sie Zeitraum und Filter.',
    search: 'Suche',
    period: 'Zeitraum',
    projects: 'Projekte',
    stages: 'Phasen',
    search_placeholder: 'Nach Name oder Nummer suchen',
    projects_placeholder: 'Alle Projekte',
    stages_placeholder: 'Alle Phasen',
    all: 'Gesamter Zeitraum',
    today: 'Heute',
    yesterday: 'Gestern',
    last_week: 'Letzte Woche',
    last_month: 'Letzter Monat',
    older: 'Älter',
  },
  myTasks: {
    task_sorted_by_priority: 'Aufgaben nach Priorität',
    mentions: 'Erwähnungen',
    recents: 'Kürzlich',
    liked: 'Favoriten',
    total: 'insgesamt',
    total_unreads: 'ungelesen',
    total_updates: 'Aktualisierungen',
    no: 'keine',
    markAllAsRead: 'Alle als gelesen markieren',
    marking: 'Wird markiert...',
    confirmMarkAllAsRead: 'Alle Erwähnungen als gelesen markieren?',
    confirmMarkAllAsReadMessage: 'Damit werden alle Aufgaben mit Erwähnungen als gelesen markiert. Diese Aktion kann nicht rückgängig gemacht werden.',
    openProject: 'Projekt öffnen',
    open: 'Öffnen',
  },
  menu: {
    Pause: 'Pause',
    PauseUntilWindowActivation: 'Pausieren bis Fenster aktiviert wird',
    PauseFor5Minutes: 'Für 5 Minuten pausieren',
    PauseFor10Minutes: 'Für 10 Minuten pausieren',
    Resume: 'Fortsetzen',
    myTasks: 'Meine Aufgaben',
    nav_menu: 'Menü',
    nav_tasks: 'Aufgaben',
    nav_alerts: 'Hinweise',
    nav_me: 'Ich',
    task_history: 'Aufgabenverlauf',
    view_all_task_history: 'Gesamten Aufgabenverlauf anzeigen',
    __open_logs: 'Logs öffnen',
    __check_updates: 'Nach Updates suchen',
    __devtools: 'DevTools',
    __quit: 'Beenden',
    download_app: 'Desktop-App holen',
    summary_report: 'Zusammenfassender Bericht',
    dayoff: 'Freier Tag',
    time_reports: 'Zeitberichte & Rechnungen',
    time_report: 'Zeitbericht',
    invoice_generator: 'Rechnung erstellen',
    salary: 'Gehalt',
    profit_share: 'Gewinnbeteiligung',
    projects: 'Projekte',
    create_project: 'Neues Projekt erstellen',
    project_settings: 'Projekteinstellungen',
    ai_assistant: 'KI-Assistent',
    profile: 'Profil',
    dark_mode: 'Dunkelmodus',
    my_screenshots: 'Meine Screenshots',
    logout: 'Abmelden',
    get_help: 'Hilfe erhalten',
    about: 'Über',
    ai_automation: 'KI & Automatisierung',
    workspace: 'Arbeitsbereich',
    switch_workspace: 'Arbeitsbereich wechseln',
    workspace_settings: 'Arbeitsbereichseinstellungen',
    create_new_workspace: 'Neuer Arbeitsbereich',
    workspace_name: "Name des Arbeitsbereichs",
    personal_workspace: "Persönlicher Arbeitsbereich",
    create_workspace: "Erstellen",
    create_workspace_failed: "Der Arbeitsbereich konnte nicht erstellt werden, bitte versuche es erneut",
    invite_to_project: 'Nutzer zum Projekt einladen',
    already_member_project: 'Der Nutzer ist bereits Mitglied des Projekts',
    resend_invite_button: 'EINLADUNG ERNEUT SENDEN',
    no_users_found: 'Kein Nutzer gefunden, E-Mail eingeben, um einzuladen.',
    invite_failed: '{email} konnte nicht eingeladen werden: prüfe die Adresse',
    settings: 'Einstellungen',
    Project_name: 'Projektname',
    task_short_id: 'Wird für kurze Aufgaben-IDs verwendet',
    Task_ID_example: 'Beispiel für Aufgaben-ID',
    already_taken: 'Im Arbeitsbereich bereits vergeben',
    Please_change: 'Bitte ändern',
    Prefix: 'Präfix',
    Template: 'Vorlage',
    Project_background: 'Projekthintergrund',
    change: 'ÄNDERN',
    create: 'ERSTELLEN',
    Select_a_picture: 'Bild auswählen',
    Examples: 'Beispiele:',
    pick_a_color: 'Oder Farbe wählen',
    create_project_hint: 'Benenne es, wähle eine Spaltenvorlage und einen Hintergrund.',
    Search_pictures: 'Bilder suchen — abstrakt, Verlauf, Lichter…',
    Create_project: 'Projekt erstellen',
    Resend_invite: 'Einladung zu Projekt und Arbeitsbereich erneut senden an',
    user_invite: 'Klicke auf einen Nutzer, um ihn einzuladen',
    get_app: 'App holen',
    add_task: 'Hinzufügen',
    mentions_notify_1: 'Du hast',
    mentions_notify_2_single: 'Aufgabe mit Erwähnung',
    mentions_notify_2_multy: 'Aufgaben mit Erwähnungen',
    task_create: 'Aufgabe erstellen',
    notifications: 'Benachrichtigungen',
    no_new_notifications: 'Keine neuen Benachrichtigungen',
    new_notification: 'neu',
    new_notifications: 'neu',
  },
  reports: {
    executors: 'Ausführende',
    now_working: 'Arbeitet jetzt',
    no_active_tasks: 'Keine aktiven Aufgaben',
    work_one_day: 'Arbeit an einem Tag',
    today: 'HEUTE',
    work_this_month: 'Arbeit in diesem Monat',
    member: 'Mitglied',
    activity: 'Aktivität',
    total: 'Gesamt',
    no_time_tracked: 'Keine Zeit erfasst',
    no_time_tracked_this_month: 'In diesem Monat keine Zeit erfasst',
    date_range: 'Zeitraum',
    select_date_range: 'Zeitraum auswählen',
    show_filters: 'Filter anzeigen',
    hide_filters: 'Filter ausblenden',
    filter_projects: 'Projekte einbeziehen',
    select_projects: 'Projekte auswählen',
    filter_labels: 'Nur Aufgaben mit Tags',
    filter_exclude_labels: 'Aufgaben mit Tags ausschließen',
    select_label: 'Tag auswählen',
    filter_executors: 'Ausführende filtern',
    select_executors: 'Ausführende auswählen',
    group_by: 'Gruppieren nach',
    group_projects: 'Projekte',
    by_weeks: 'Nach Wochen',
    by_month: 'Nach Monat',
    dont_group: 'Nicht gruppieren',
    no_tasks: 'Keine Aufgaben für diese Anfrage',
    total_time: 'Gesamtzeit',
    total_time_by_day: 'Gesamtzeit pro Tag',
    burnup_chart: 'Burnup-Diagramm',
    all_spent: 'GESAMT<br/>AUFGEWENDET',
    time_by_task: 'Zeit pro Aufgabe',
    invoice: 'Rechnung erstellen',
    roles: 'Rollen',
    search: 'Suchen',
    select_all: 'Alle auswählen',
    unselect_all: 'Auswahl aufheben',
    now: 'jetzt',
    Enter_project_name: 'Projektnamen eingeben',
    screenshots: 'SCREENSHOTS',
    empty: 'Leer',
    screenshots_empty_title: 'Keine Screenshots',
    screenshots_empty_hint: 'Für die gewählten Daten und Filter wurde nichts aufgenommen.',
    time_empty_title: 'Keine erfasste Zeit',
    time_empty_hint: 'Für die gewählten Daten und Filter wurde keine Zeit erfasst.',
    last_month: 'Letzter Monat',
    this_month: 'Dieser Monat',
    this_year: 'Dieses Jahr',
    all_time: 'Gesamte Zeit',
    Ok: 'Ok',
    YES: 'JA',
    CANCEL: 'ABBRECHEN',
    Cancel: 'Abbrechen',
    Tasks: 'AUFGABEN',
    Time: 'Zeit',
    Tasks_details: 'AUFGABENDETAILS',
    PriorityLow: 'Niedrig',
    PriorityUsual: 'Normal',
    PriorityHigh: 'Hoch',
    PriorityUrgent: 'Dringend',
    PrioritySuperUrgent: 'Sehr dringend',
    Unset: 'Nicht gesetzt',
    enter_variables_values: 'Werte der Variablen eingeben',
    are_you_sure_delete_template: 'Möchtest du die Vorlage wirklich löschen?',
    are_you_sure_new_template: 'Möchtest du diese Vorlage wirklich speichern?',
    Template: 'Vorlage',
    Select_template: 'Vorlage auswählen',
    New_template_name: 'Name der neuen Vorlage',
    DOWNLOAD_PDF: 'PDF HERUNTERLADEN',
    basic_example: 'Einfaches Beispiel',
    worker_salary: 'Mitarbeitergehalt',
    devforth_salary: 'Devforth-Gehalt',
    executor: 'Ausführender',
    created: 'Erstellt',
    contributors: 'Beitragende',
    value: 'Wert',
    progress: 'Fortschritt',
    accuracy: 'Genauigkeit',
    spent_by: 'Aufgewendet von',
    by_executor: 'Ausführender',
    total_spent_by: 'Gesamt aufgewendet',
    by_contributors: 'von Beitragenden',
    export: 'Exportieren',
    configure_columns: 'Spalten konfigurieren',
    more_actions: 'Weitere Aktionen',
    round_hours_to: 'Stunden runden auf',
    export_to_csv: 'Als CSV exportieren',
    export_to_gsheets: 'Nach Google Sheets exportieren',
  },
  placeholders: {
    e_g: 'z. B. Neues Projekt',
    Type_anything: 'Beliebigen Text eingeben',
  },
  settings: {
    configure: 'Projekt konfigurieren',
    delete_project: 'Projekt löschen',
    Can_not_be_empty: 'Darf nicht leer sein',
    New_prefix: 'Neues Präfix',
    Save: 'Speichern',
    SaveAs: 'Speichern unter',

    Cancel: 'Abbrechen',
    general: 'Allgemein',
    Labels: 'Tags',
    Members: 'Mitglieder',
    Tracker_Rules: 'Flow-Schaltflächen',
    Stages: 'Phasen',
    No_labels_yet: 'Noch keine Tags',
    Admin: 'Administrator',
    Not_a_member: 'Kein Mitglied',
    Member: 'Mitglied',
    Role_on_project: 'Rolle im Projekt',
    Actions: 'Aktionen',
    Permissions: 'Berechtigungen',
    Other: 'Sonstiges',
    Invite_member: 'Mitglied einladen',
    exclude_the_user: 'Möchtest du den Nutzer wirklich aus dem Projekt ausschließen?',
    Exclude: 'Ausschließen',
    Configure_workspace: 'Arbeitsbereich konfigurieren',
    Workspace_name: 'Name des Arbeitsbereichs',
    Logo: 'Logo',
    save: 'Speichern',
    Workspace_UI_language: 'Sprache des Arbeitsbereichs',
    Workspace_alias: 'Alias des Arbeitsbereichs',
    General: 'Allgemein',
    Priorities: 'Prioritäten',
    Edit_tag_name: 'Tag-Namen bearbeiten:',
    Pick_a_color: 'Farbe wählen',
    DELETE_TAG: 'TAG LÖSCHEN',
    ARCHIVE_TAG: 'TAG ARCHIVIEREN',
    UNARCHIVE_TAG: 'TAG WIEDERHERSTELLEN',
    TASKS: 'AUFGABEN',
    EDIT: 'BEARBEITEN',
    confirm_delete: 'Möchtest du das Projekt wirklich löschen?',
    archive: 'Archivieren | archivieren | Archiviert',
    unarchive: 'Wiederherstellen | wiederherstellen',
    confirm_archive: 'Möchtest du dieses Projekt {action}?',
    cant_undone: 'Dies kann nicht rückgängig gemacht werden',
    confirm_user_deletion: 'Möchtest du den Nutzer wirklich löschen?',
    CANCEL: 'ABBRECHEN',
    YES: 'JA',
    Yes: 'Ja',
    delete: 'Löschen',
    only_admin_can_delete_user: 'Nur der Administrator des Arbeitsbereichs kann ein Mitglied löschen',
    only_admin_can_change_language: 'Nur der Administrator des Arbeitsbereichs kann die Sprache ändern',
    ADMIN: 'Administrator',
    MEMBER: 'Teammitglied',
    GUEST: 'Gast',
    FINANCE: 'Finanzverantwortlicher',
    admin_description: 'Hat vollen Zugriff',
    finance_description: 'Wie ein Mitglied, hat aber zusätzlich Zugriff auf alle Rechnungsvorlagen',
    member_description: 'Hat nur Zugriff auf Projekte, zu denen er eingeladen wurde, kann aber Zeitberichte aller Mitglieder und aller Projekte sehen. Kann Aufgabennamen fremder Projekte sehen.',
    guest_description: 'Hat nur Zugriff auf Projekte, zu denen er eingeladen wurde, und sieht Zeitberichte aller Mitglieder dieser Projekte.',
    doScreenshots: 'Screenshots als Arbeitsnachweis erstellen',
    single_admin_role_warning: 'Du kannst die Berechtigungen des einzigen Administrators nicht ändern',
    owner_role_warning: 'Du kannst die Berechtigungen des Eigentümers des Arbeitsbereichs nicht ändern',
  },
  workspaceSettings: {
    general_subtitle: 'Workspace-Name, Logo, Sprache und Markenfarbe',
    members_subtitle: 'Personen in diesem Workspace und ihre Rollen',
    priorities_subtitle: 'Projektreihenfolge in „Meine Aufgaben“ jedes Mitglieds',
    name_saved: 'Workspace-Name gespeichert',
    logo_saved: 'Workspace-Logo gespeichert',
    timezone_saved: 'Hauptzeitzone gespeichert',
    brand_color: 'Markenfarbe',
    main_timezone: 'Hauptzeitzone',
    search_timezone: 'Zeitzone suchen',
    language: 'Sprache',
    role: 'Rolle',
    admins: 'Admins',
    pending_invites: 'Offene Einladungen',
    name_hint: 'Wird im Workspace-Umschalter und in Einladungen angezeigt.',
    language_hint: 'Standard für alle im Workspace.',
    brand_color_hint: 'Wird in nach Google Sheets exportierten Berichten verwendet.',
    timezone_hint: 'Zeitberichte und Rechnungen zählen Tage in dieser Zeitzone. Nur Eigentümer und Admins können sie ändern.',
  },
  projectSettings: {
    group_project: 'Projekt',
    group_people: 'Personen',
    group_automation: 'Automatisierung',
    integrations: 'Integrationen',
    general_subtitle: 'Projektname und Darstellung',
    tags_subtitle: 'Labels zur Kategorisierung der Aufgaben auf diesem Board',
    stages_subtitle: 'Spalten des Boards — Reihenfolge ändern, um den Ablauf zu ändern',
    members_subtitle: 'Personen mit Zugriff auf dieses Projekt und ihre Rollen',
    flow_subtitle: 'Aktionen der großen Flow-Buttons auf der Aufgabenseite, pro Phase',
    integrations_subtitle: 'Verbundene Dienste, die an Tracklify berichten',
    tasks_total: 'Aufgaben gesamt',
    name_hint: 'Wird in der Seitenleiste, im Board-Header und in jedem Aufgabenverweis angezeigt.',
    background: 'Board-Hintergrund',
    background_hint: 'Bild hinter den Board-Spalten. Dezent gehalten, damit Karten lesbar bleiben.',
    no_background: 'Kein Hintergrund',
    photo_by: 'Foto von',
    screenshots_hint: 'Screenshots während der Timer läuft, an die erfasste Zeit angehängt.',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    change: 'Ändern',
    archive_title: 'Projekt archivieren',
    archive_hint: 'Blendet es in der Seitenleiste und im Board-Wechsler aus. Erfasste Zeit bleibt in Berichten — Wiederherstellung jederzeit möglich.',
    archive_button: 'Projekt archivieren',
    unarchive_title: 'Projekt wiederherstellen',
    unarchive_hint: 'Bringt es zurück in die Seitenleiste und den Board-Wechsler.',
    unarchive_button: 'Archivierung aufheben',
    delete_title: 'Projekt löschen',
    delete_hint: 'Entfernt das Projekt mitsamt seinen Aufgaben.',
    tag: 'Tag',
    used_on: 'Verwendet in',
    tasks_count: '{count} Aufgaben',
    edit: 'Bearbeiten',
    archived: 'Archiviert',
    archive: 'Archivieren',
    unarchive: 'Wiederherstellen',
    add_tag: 'Tag hinzufügen',
    new_tag: 'Neuer Tag',
    tag_name: 'Tag-Name',
    create: 'Erstellen',
    stage: 'Phase',
    tasks: 'Aufgaben',
    order: 'Reihenfolge',
    add_stage: 'Phase hinzufügen',
    stage_name: 'Name der Phase',
    rename_stage: 'Phase umbenennen',
    stage_name_hint: 'Wird als Spaltentitel auf dem Board angezeigt.',
    to_save: 'zum Speichern',
  },
  projectRules: {
    when_task_in_stage: 'Wenn Aufgabe in Phase',
    secondary_button: 'Sekundäre Schaltfläche (links)',
    primary_button: 'Primäre Schaltfläche',
    this_rule_willnot_work: 'Diese Regel wird nicht funktionieren',
    add_action: 'Aktion hinzufügen',
    similar_item_was_used: 'ein ähnliches Element wurde verwendet',
    preview: 'Vorschau',
    move: 'Verschieben',
    move_to: 'Verschieben nach',
    assign: 'Zuweisen',
    assign_if_not_assigned: 'Zuweisen, falls nicht zugewiesen',
    assign_mention: 'Erwähnte Person zuweisen',
    unassign: 'Zuweisung entfernen',
    auto_click_after: 'Automatisch klicken nach',
    activate_button_if_user_mentioned_in_comment: 'Schaltfläche aktivieren, wenn der Nutzer im Kommentar erwähnt wird',
    auto_click_after_tracked_1: 'Automatisch klicken nach',
    auto_click_after_tracked_2: 'erfasst',
    minutes: 'Min.',
    Me: 'Ich',
    Task_creator: 'Ersteller der Aufgabe',
    no_buttons: 'Keine Buttons angezeigt',
  },
  task: {
    edited: 'bearbeitet',
    Actions: 'Aktionen',
    noDescription: 'Noch keine Beschreibung',
    timeSpent: 'Aufgewendete Zeit',
    ago: 'zuvor',
    by: ', von',
    ADD_A_CHECKLIST: 'CHECKLISTE HINZUFÜGEN',
    ADD_A_CHECKLIST_ITEM: 'CHECKLISTENPUNKT HINZUFÜGEN',
    Created_task_in: 'Aufgabe erstellt in',
    Assigned: 'Zugewiesen',
    Changed_task_description: 'Aufgabenbeschreibung geändert',
    Transferred_task_from: 'Aufgabe übertragen von',
    Type_comment: 'Kommentar schreiben',
    SET_EST: 'SCHÄTZUNG',
    SET_ESTIMATE: 'SCHÄTZUNG SETZEN',
    Clear: 'Löschen',
    STORY_POINTS: 'STORY POINTS',
    Estimate: 'Schätzung',
    Progress: 'Fortschritt',
    Add_time: 'Zeit hinzufügen',
    est: 'Schätz.',
    Code_block: 'Codeblock',
    List: 'Liste',
    Video: 'Video',
    USUAL: 'NORMAL',
    PRIO: 'Priorität',
    Set_estimate_to: 'Schätzung setzen auf',
    Set_priority: 'Priorität setzen',
    Delete_task: 'Aufgabe löschen',
    Screenshots: 'Screenshots ansehen',
    Add_manual_time: 'Zeit manuell hinzufügen',
    Add_to_liked: 'Zu Favoriten hinzufügen',
    CANCEL: 'ABBRECHEN',
    YES: 'JA',
    Back_to_task: 'Zurück zur Aufgabe',
    What_were_you_doing: 'Woran hast du gearbeitet?',
    manual_how_long: 'Wie lange?',
    manual_set_exactly: 'oder genau festlegen',
    manual_description_placeholder: 'z. B. Kundengespräch zur Q4-Roadmap',
    manual_request: '{duration} anfragen',
    manual_pick_hint: 'Ziehe auf der Leiste, um zu wählen, wann du gearbeitet hast',
    manual_tab_range: 'Zeitraum',
    manual_tab_duration: 'Dauer',
    manual_today: 'Heute',
    manual_earlier: 'Früher',
    manual_later: 'Später',
    manual_legend_tracked: 'Erfasst',
    manual_legend_request: 'Diese Anfrage',
    manual_time_admin_required: 'Manuelle Zeit wird von einem Workspace-Admin geprüft, und dieses Projekt hat keinen. Füge einen zum Projekt hinzu:',
    manual_time_request_refused: 'Manuelle Zeit wurde nicht angefragt. Lade die Seite neu und versuche es erneut.',
    manual_time_update_refused: 'Manuelle Zeit wurde nicht aktualisiert: Sie wurde bereits bearbeitet oder du hast keinen Zugriff mehr. Lade die Seite neu, um den aktuellen Stand zu sehen.',
    Type_item: 'Punkt eingeben',
    to_normal: 'auf normal',
    ASSIGN: 'Zuweisen',
    SEARCH_ASSIGNEE: 'Nach Zuständigem suchen',
    add: 'hinzufügen',
    change: 'ändern',
    nowin: 'jetzt in',
    Tags: 'Tags',
    Unassign: 'Zuweisung entfernen',
    just_now: 'gerade jetzt',
    Removed_assignee: 'Zuständigen entfernt',
    Moved_to: 'Verschoben nach',
    Added_tag: 'Tag hinzugefügt',
    Removed_tag: 'Tag entfernt',
    Added: 'Hinzugefügt',
    Reqested_to_add: 'Hinzufügen angefragt',
    Approved: 'Genehmigt',
    Rejected: 'Abgelehnt',
    Canceled: 'Abgebrochen',
    Deleted: 'Gelöscht',
    by_trigger: 'durch Auslöser',
    REMOVE: 'ENTFERNEN',
    Are_you_sure: 'Bist du sicher?',
    Are_you_sure_you_want_to_delete_this_image: 'Möchtest du dieses Bild wirklich löschen?',
    set_as_task_preview: 'Als Aufgabenvorschau festlegen',
    max_images_reached: 'Du kannst maximal {limit} Bilder auf einmal hochladen',
    current_task_preview: 'Aktuelle Aufgabenvorschau',
    next_image: 'Nächstes Bild',
    previous_image: 'Vorheriges Bild',
    Are_you_sure_you_want_to_delete_this_comment: 'Möchtest du diesen Kommentar wirklich löschen?',
    Are_you_sure_you_want_to_delete_this_checklist_item: 'Möchtest du diesen Checklistenpunkt wirklich löschen?',
    Delete: 'Löschen',
    Yes: 'Ja',
    No: 'Nein',
    manual_CANCEL: 'Abbrechen',
    manual_Remove: 'Entfernen',
    manual_YES: 'JA',
    delete_screenshot_title: 'Diesen Screenshot löschen?',
    delete_screenshot_subtitle: 'Dies kann nicht rückgängig gemacht werden',
    Add_tags: 'Tags hinzufügen',
    create_new_tag: 'Neuen Tag erstellen',
    No_screenshots_here_enable: 'Hier gibt es noch keine Screenshots, erfasse Zeit und sie werden erscheinen',
    No_screenshots_here_disable: 'Screenshots sind für dieses Projekt deaktiviert',
    No_screenshots_here_disable_admin_part1: 'Screenshots sind für dieses Projekt deaktiviert, öffne die ',
    No_screenshots_here_disable_admin_part2: 'Einstellungen',
    No_screenshots_here_disable_admin_part3: ', um das zu ändern',
    SPENT: 'AUFGEWENDET',
    oops: 'Ups!',
    cannot_find_page: 'Wir können die gesuchte Seite nicht finden',
    start_from_home: 'Von der Startseite beginnen',
    nf_title: 'Hier gibt es nichts zu sehen.',
    nf_subtitle: 'Die angeforderte Seite existiert nicht. Überprüfe die URL oder kehre zu einem bekannten Ort zurück.',
    go_to_homepage: 'Zur Startseite',
    go_back: 'Zurück',
    spent_time: 'Aufgewendete Zeit',
    copy_to_clipboard: 'In die Zwischenablage kopieren',
    copied_to_clipboard: 'Link wurde in die Zwischenablage kopiert',
    copy_video_link: 'Link kopieren',
    volume: 'Lautstärke',
    converting_video: 'Wird konvertiert…',
    picture_in_picture: 'Bild im Bild',
    expand_video: 'Vergrößern',
    collapse_video: 'Verkleinern',
    we_are_still_processing_video: 'Wir verarbeiten das Video noch',
    video_available_not_for_all_platforms: 'Das Video ist auf Plattformen, die moderne Videoformate nicht unterstützen, noch nicht verfügbar. Wir konvertieren es zusätzlich nach MP4. Bitte warten.',
    move_to: 'Verschieben nach',
    unassign: 'Zuweisung entfernen',
    assign: 'Zuweisen',
    unable_to_restore_image: 'Das Bild konnte nicht wiederhergestellt werden',
    Record_screen: 'Bildschirm aufzeichnen',
    screenshot_activity: 'Aktivität',
    my_last_screenshots: 'Meine letzten Screenshots',
    view_all: 'Alle ansehen',
    Executor: 'Ausführender',
    edit: 'bearbeiten',
    Stage: 'Phase',
    NoStage: 'Keine Phase',
    Change_project: 'Projekt wechseln',
    Please_select_project_to_move: 'Bitte Projekt zum Verschieben auswählen',
    No_transfer_available: 'Keine Übertragung möglich',
    Created_by: 'Erstellt von',
    PriorityLow: 'Niedrig',
    PriorityUsual: 'Normal',
    PriorityHigh: 'Hoch',
    PriorityUrgent: 'Dringend',
    PrioritySuperUrgent: 'Sehr dringend',
    Unset: 'Nicht gesetzt',
    transfer_unavailable: {
      not_creator: 'Nur der Ersteller kann übertragen, und du bist nicht der Ersteller',
      single_project: 'Es gibt nur ein Projekt, also kein Projekt zum Übertragen',
      child_task: 'Eine einzelne Teilaufgabe kann nicht übertragen werden',
    },
    are_you_sure_transfer_task: 'Möchtest du die Aufgabe wirklich übertragen?',
    time_save_but_screenshots_unavailable: 'Screenshots der Zeiterfassung und die erfasste Zeit werden gespeichert, sind aber in der übertragenen Aufgabe nicht verfügbar.',
    screenshots_from_tracked_time: 'Screenshots aus der Zeiterfassung',
  },
  theme: {
    title: 'Design',
    dark: 'Dunkel',
    light: 'Hell',
    pink: 'Pink',
    violet: 'Violett',
    lime: 'Lindgrün',
  },
  themeEditor: {
    new_theme: 'Neues Theme',
    new_title: 'Neues Theme',
    edit_title: 'Theme bearbeiten',
    unsaved_message: 'Deine Änderungen am Theme sind noch nicht gespeichert.',
    name: 'Name',
    name_placeholder: 'Mein Theme',
    mode: 'Modus',
    colors: 'Farben',
    seed_base: 'Hintergrund',
    seed_ink: 'Text',
    seed_accent: 'Akzent',
    fine_tune: 'Feinabstimmung',
    overrides_hint: 'Optional. Leere Farben folgen den Farben oben.',
    token_bg2: 'Panels',
    token_control: 'Buttons',
    token_card: 'Karten',
    token_chrome: 'Obere Leiste',
    token_line: 'Rahmen',
    'token_text-muted': 'Nebentext',
    'token_accent-soft': 'Akzent-Tönung',
    token_red: 'Rot',
    token_green: 'Grün',
    token_blue: 'Blau',
    reset: 'Zurücksetzen',
    share: 'Mit Workspace teilen',
    share_hint: 'Mitglieder von {workspace} können es auch wählen',
    shared: 'Mit dem Workspace geteilt',
    shared_by: 'Geteilt von {name}',
    delete: 'Löschen',
    delete_title: 'Theme löschen?',
    cancel: 'Abbrechen',
    save: 'Speichern',
    preview: 'Vorschau',
    preview_project: 'Website-Redesign',
    preview_search: 'Suchen',
    preview_filters: 'Filter',
    preview_filter_mine: 'Meine Aufgaben',
    preview_filter_tagged: 'Mit Tags',
    preview_filter_tracked: 'Heute erfasst',
    preview_todo: 'Zu erledigen',
    preview_doing: 'In Arbeit',
    preview_done: 'Erledigt',
    preview_card_onboarding: 'Onboarding-Screens',
    preview_card_ora: 'ORA ORA ORA-Spam in Kommentaren begrenzen',
    preview_card_invoices: 'Monatsrechnungen',
    preview_card_icons: 'Neues Icon-Set',
    preview_card_clash_royale: 'Nerf Mega Knight',
    preview_tag_bug: 'Bug',
    preview_tag_design: 'Design',
    preview_tag_release: 'Release',
  },
  profile: {
    password_title: 'Machen Sie es schwer zu erraten',
    password_hint: 'Die Anforderungen leuchten auf, während Sie tippen.',
    rule_length: '{count} oder mehr Zeichen',
    rule_number: 'Mindestens eine Ziffer',
    rule_uppercase: 'Ein Großbuchstabe',
    rule_match: 'Beide Passwörter stimmen überein',
    rule_no_spaces: 'Keine Leerzeichen',
    rule_different: 'Unterscheidet sich vom aktuellen Passwort',
    save_password: 'Passwort speichern',
    username_required: 'Name darf nicht leer sein',
    profile_saved: 'Profil gespeichert',
    username_invalid: "Der Name darf nur Buchstaben, Ziffern, Leerzeichen und . , - _ ' ’ & ( ) {'@'} + enthalten",
    profile_save_failed: "Profil konnte nicht gespeichert werden, bitte versuche es erneut",
    password_changed: 'Passwort geändert',
    delete_title: 'Ihr Konto löschen?',
    will_be_removed: 'Wird entfernt',
    removed_profile: 'Profil, Foto und Einstellungen',
    removed_access: 'Zugriff auf alle Workspaces und Projekte',
    removed_settings: 'Freie Tage und persönliche Einstellungen',
    type_delete_prefix: 'Geben Sie',
    type_delete_suffix: 'zur Bestätigung ein',
    keep_account: 'Konto behalten',
    delete_forever: 'Endgültig löschen',
    subtitle: 'Ihre persönlichen Kontodaten und Einstellungen',
    section_photo: 'Profilfoto',
    section_personal: 'Persönliche Informationen',
    section_appearance: 'Darstellung',
    section_security: 'Sicherheit',
    section_danger: 'Gefahrenzone',
    upload_new: 'Neues hochladen',
    photo_hint: 'PNG oder JPG, bis zu 5 MB',
    name_hint: 'Für Ihre Teamkollegen in Aufgaben und Kommentaren sichtbar',
    theme_hint: 'Gilt für alle Ihre Tracklify-Workspaces und Geräte',
    change_password: 'Passwort ändern',
    delete_account_hint: 'Entfernt Ihr Konto und alle persönlichen Daten dauerhaft. Das kann nicht rückgängig gemacht werden.',
    delete_account_button: 'Konto löschen',
    Cancel: 'Abbrechen',
    old_password_placeholder: 'Aktuelles Passwort eingeben',
    new_password_placeholder: 'Mindestens {count} Zeichen',
    repeat_password_placeholder: 'Neues Passwort wiederholen',
    days_off_visibility_hint: 'Wählen Sie, wer sieht, wenn Sie in Ihren Projekten abwesend sind',
    days_off_everyone: 'Alle',
    days_off_members_only: 'Nur Mitglieder',
    unsaved_changes: 'Sie haben ungespeicherte Änderungen',
    Configure_user_profile: 'Nutzerprofil konfigurieren',
    General: 'Allgemein',
    Privacy: 'Datenschutz',
    days_off_visibility_title: 'Wer kann meine freien Tage sehen?',
    days_off_visible_to_everyone: 'Alle in meinen Projekten, einschließlich Arbeitsbereichsgästen',
    days_off_hidden_from_guests: 'Nur Arbeitsbereichsmitglieder und Administratoren in meinen Projekten',
    Name_Surname: 'Vor- und Nachname',
    Avatar: 'Avatar',
    Email: 'E-Mail',
    CHANGE_PASSWORD: 'PASSWORT ÄNDERN',
    DELETE_ACCOUNT: 'NUTZERKONTO LÖSCHEN',
    Old_password: 'Altes Passwort',
    New_password: 'Neues Passwort',
    Repeat_new_password: 'Neues Passwort wiederholen',
    CANCEL: 'ABBRECHEN',
    Fill_this_field: 'Dieses Feld ausfüllen',
    Old_password_is_incorrect: 'Das alte Passwort ist falsch',
    Password_must_be_same: 'Die Passwörter müssen übereinstimmen',
    Change_user_password: 'Nutzerpasswort ändern',
    Password_must_be_at_least: 'Das Passwort muss mindestens',
    characters: 'Zeichen lang sein',
    destroy_your_account: 'Dadurch wird dein Nutzerkonto endgültig gelöscht',
    type_delete_to_confirm: 'Tippe DELETE, wenn du sicher bist',
    delete_me: 'LÖSCHE MICH',
  },
  time: {
    M: 'M',
    S: 'S',
    d: 'T',
    w: 'W',
    y: 'J',
    H: 'Std',
  },
  button: {
    Yes: 'Ja',
  },
  recording: {
    Record_your_screen: 'Bildschirm aufzeichnen',
    Record_Microphone: 'Mikrofon aufzeichnen',
    Record_Webcam: 'Webcam aufzeichnen',
    cant_start_rec: 'Bildschirmaufzeichnung kann nicht gestartet werden, hast du einen Bildschirm ausgewählt? Fehler',
    Cant_start_camera: 'Kameraaufzeichnung kann nicht gestartet werden, hast du die Berechtigungen erteilt? Fehler',
    Webcamera_preview: 'Webcam-Vorschau',
    Start_recording: 'Aufzeichnung starten',
    recording_screen_now: 'Du zeichnest deinen Bildschirm gerade auf',
    Stop_recording: 'Aufzeichnung beenden',
  },
  loader: {
    Loading: 'Wird geladen',
  },
  rule: {
    When: 'Wenn',
    Else: 'Sonst',
    Action: 'Aktion',
    Condition: 'Bedingung',
  },
  trackTimeBar: {
    Unassign: 'Zuweisung entfernen',
  },
  downloadMobile: {
    Get_Tracklify_mobile: 'Hol dir die Tracklify Mobile-App',
    Browse: 'Durchsuchen',
    discuss_your_tasks: 'diskutiere deine Aufgaben, verwalte das Team mobil oder',
    quickly_creates_tasks: 'erstelle schnell Aufgaben aus geteilten Screenshots',
    You_have_Tracklify: 'Du hast die Tracklify-App bereits auf deinem Smartphone',
    Reports: 'Berichte',
  },
  title: {
    select_text_and: 'Text markieren und Ctrl + L',
  },
  trackingNotice: {
    __tracking_going: 'Tracklify erstellt Screenshots, um deine aufgewendete Arbeitszeit zu belegen',
    __please_share: 'Bitte teile deinen gesamten Bildschirm, damit wir ihn aufnehmen können',
    __choose_entire_screen: 'Wähle im Browserfenster Gesamter Bildschirm und klicke dann auf Teilen',
    __window_or_tab_wont_work: 'Das Teilen eines einzelnen Fensters oder Chrome-Tabs funktioniert nicht',
    __tracking_makes_screenshots:
      'Tracklify erstellt nur einen Screenshot pro 10 Minuten mit einer kleinen zufälligen Zeitverschiebung',
    __screenshots_securely:
      'Screenshots werden sicher in der Cloud gespeichert und können jederzeit überprüft und entfernt werden (mit Zeitverlust)',
    __press_cancel: 'Bitte drücke Abbrechen, wenn du deine Zeit nicht belegen möchtest',
    __good_try: 'Guter Versuch!',
    __selected_one: 'Aber du hast ausgewählt',
    __selected_two: 'anstatt des gesamten Bildschirms',
    __canceled_sharing: 'Du hast die Bildschirmfreigabe abgebrochen',
    __unfortunately: 'Daher kannst du deine Zeit nicht bestätigen',
    __you_ws_admin: 'Da du Administrator des Arbeitsbereichs bist, kannst du:',
    __we_will_notify: 'Wir benachrichtigen dich, wenn ein Screenshot erstellt wird oder die Erfassung stoppt',
    __please_notify: 'bitte Benachrichtigungen erlauben',
    __notifications_only:
      'Tracklify nutzt Benachrichtigungen nur, um dich über den Status der Zeiterfassung zu informieren',
    __we_recommended_notifications:
      'Wir empfehlen außerdem, in den Systemeinstellungen sicherzustellen, dass Browser-Benachrichtigungen aktiviert sind',
    __we_recommended_idle: 'Wir empfehlen, die Berechtigung „Gerätenutzung“ zu aktivieren',
    __we_will_idle: 'Wir prüfen deine Inaktivität',
    __needs_device_use:
      'Tracklify nutzt die Berechtigung „Gerätenutzung“, um die Erfassung automatisch zu stoppen, wenn du den Computer länger als 10 Minuten verlässt.',
    __provide_better:
      'Diese Einstellung dient nur einer besseren Nutzererfahrung, es werden keine Daten zur Gerätenutzung an den Server gesendet.',
    __well_done: 'Gut gemacht',
    __we_recommended_hide_popup: 'Wir empfehlen, das störende Browser-Popup auszublenden',
    __just_press: 'Drücke einfach Ausblenden:',
    __to_leave: 'Um deine Arbeit zu beenden und die Erfassung zu stoppen, schließe einfach den Browser-Tab mit Tracklify',
    __sorry_we_cant: 'Leider können wir die Erfassung nicht starten',
    __we_dont_have_perm: 'Wir haben keine Berechtigung für den Zugriff auf deine Aktivität. Bitte setze alle Berechtigungen zurück, damit der Browser sie erneut anfragen kann.',
    __try_again_btn: 'Erneut versuchen',
    __dont_track: 'Okay, Stunden nicht erfassen',
    __enable_without: 'Zeiterfassung ohne Screenshots für das Projekt aktivieren',
    __dont_show_again: 'Nicht mehr anzeigen',
    __close: 'Schließen',
    andReload: 'Und Seite neu laden',
    __choose_chrome_browser: 'Da Tracklify die moderne IDLE-Detection-API nutzt, funktioniert es nur im Chrome-Browser (oder anderen Chrome-basierten Browsern)',
    __otherwise: 'Andernfalls kannst du hier unsere Desktop-App herunterladen:',
    __download: 'HERUNTERLADEN',
    __update_tracker: 'Aktualisieren',
    __installing_update: 'Wird installiert…',
    __update_failed: 'Update fehlgeschlagen. Klicke auf „Aktualisieren“, um es erneut zu versuchen.',
    __you_can_disable_screenshots: 'Da du der Ersteller des Projekts bist, kannst du Screenshots deaktivieren in den',
    __project_settings: 'Projekteinstellungen',
  },
  addTask: {
    tags: 'Tags',
    no_tags: 'Keine Tags',
    no_tags_hint: 'Dieses Projekt hat noch keine Tags.',
    add_tags: 'Tags hinzufügen',
    search_tags: 'Tags suchen...',
    nothing_found: 'Nichts gefunden',
    create_tag: '«{name}» erstellen',
    clear_all: 'Alle löschen',
    more_available: '{count} weitere verfügbar',
    create_task: 'Aufgabe erstellen',
    create_subtask_for: 'Unteraufgabe erstellen für {task}',
    placeholder: 'Aufgabentext hier eingeben',
    select_picture: 'Bild auswählen',
    ctrl_v_paste: 'Ctrl+V, um ein Bild aus der Zwischenablage einzufügen',
    tap_to_attach: 'Tippen, um ein Bild anzuhängen',
    or: 'oder',
    select_exactly_image: 'Bitte wähle eine Bilddatei aus',
  },
  invoiceAutoGen: {
    button: 'Automatisch erstellen',
    save_template_first: 'Speichere zuerst die Vorlage',
    title: 'Rechnung automatisch erstellen',
    description: 'Wird am 1. jedes Monats für den Vormonat mit den aktuellen Berichtsfiltern erstellt.',
    active: 'Aktiv',
    off: 'Aus',
    next_invoice_in: 'Nächste Rechnung in 1 Tag | Nächste Rechnung in {count} Tagen',
    not_generated: 'Es werden keine Rechnungen erstellt',
    turn_off: 'Ausschalten',
    save_failed: 'Automatische Erstellung konnte nicht aktiviert werden: prüfe die Adressen',
    invoice_for: '{date} · Rechnung für {month}',
    sent_to: 'An 1 Empfänger gesendet | An {count} Empfänger gesendet',
    will_be_sent_to: 'Wird an 1 Empfänger gesendet | Wird an {count} Empfänger gesendet',
    email: 'E-Mail',
    additional_email: 'Zusätzliche E-Mail',
    additional_email_placeholder: "z. B. accountant{'@'}company.com",
    initiated_by: 'Initiiert von',
  },
  devtools: {
    title: 'KI & Automatisierung',
    subtitle: 'Arbeite mit Tracklify aus deinem Terminal und aus KI-Coding-Assistenten.',
    copy: 'Kopieren',
    regenerate: 'Neu erzeugen',
    cli: {
      terminal: 'tracklify — cli',
      title: 'Tracklify CLI holen',
      subtitle: 'Hol dir die Tracklify-CLI-Anwendung, um Operationen wie git zu automatisieren.',
      token_hint: 'Dein Token ist persönlich und geheim. Bewahre ihn sicher auf.',
      regenerate_title: 'CLI-Token neu erzeugen?',
      regenerate_subtitle: 'Alle angemeldeten Clients müssen sich erneut anmelden.',
      regenerated: 'CLI-Token neu erzeugt',
      regenerate_failed: 'CLI-Token konnte nicht neu erzeugt werden',
      branch_hint: 'Einen neuen Branch für die aktuelle Aufgabe erstellen',
      branch_output: 'Erstellt einen Branch wie feature/<projectname>/<taskHid>/<taskSlug>',
      commit_hint: 'Einen Aufgabenbezug zum Commit hinzufügen',
      commit_output: 'Erstellt einen Commit wie "my text <projectname>/<taskHid>/<taskSlug>"',
    },
    mcp: {
      terminal: 'tracklify — mcp',
      title: 'Tracklify MCP holen',
      subtitle: 'Verbinde einen MCP-Client mit deinem Tracklify-Workspace.',
      token_hint: 'Füge diesen Header mit deinem persönlichen Token hinzu. Er gewährt in deinem Namen Zugriff auf Tracklify, halte ihn also geheim.',
      regenerate_title: 'MCP-Token neu erzeugen?',
      regenerate_subtitle: 'Clients mit diesem Token verlieren den Zugriff. Über OAuth verbundene Apps funktionieren weiter.',
      regenerated: 'MCP-Token neu erzeugt',
      regenerate_failed: 'MCP-Token konnte nicht neu erzeugt werden',
      claude_code_step1: 'Im Terminal ausführen.',
      claude_code_step2: 'Dann in Claude Code ausführen, tracklify auswählen und Authenticate wählen.',
      codex_step: 'Codex öffnet Tracklify zum Anmelden im Browser; falls nicht, führe codex mcp login tracklify aus.',
      antigravity_step: 'Zu ~/.gemini/config/mcp_config.json hinzufügen. Antigravity hat keine OAuth-Anmeldung für Tracklify und nutzt deshalb deinen persönlichen Token.',
      other_step: 'Füge diese URL zu deinem MCP-Client hinzu. Mit OAuth-Anmeldung öffnet er Tracklify im Browser und fragt nach deiner Zustimmung; andernfalls füge den Header unten hinzu.',
      key: 'Schlüssel',
      value: 'Wert',
    },
    connections: {
      title: 'Verbundene Apps',
      empty: 'Über OAuth-Anmeldung ist noch keine App verbunden.',
      app: 'App',
      connected: 'Verbunden',
      last_active: 'Zuletzt aktiv',
      disconnect: 'Trennen',
      disconnect_failed: 'App konnte nicht getrennt werden',
    },
  },
  profitShare: {
    breadcrumb: 'Profit-share-Projekt /',
    search_projects: 'Profit-share-Projekte suchen',
    author: 'Autor',
    no_accessible_projects: 'Keine zugänglichen Projekte',
    confidential_badge: 'Vertraulich · Screenshots unscharf',
    projects_stack: 'Projekte',
    members_stack: 'Mitglieder',
    no_participating_projects: 'Keine beteiligten Projekte',
    only_author_access: 'Derzeit hat nur der Autor Zugriff.',
    edit_project: 'Projekt bearbeiten',
    create_project: 'Profit-share-Projekt erstellen',
    return_to_admin: 'Zur Admin-Ansicht zurück',
    view_as_non_admin: 'Als Nicht-Admin ansehen',
    loading_project: 'Profit-share-Projekt wird geladen…',
    sections_aria: 'Profit-share-Bereiche',
    tab_overview: 'Übersicht & Umsatz',
    tab_rates: 'Mitgliedersätze',
    tab_audit: 'Audit-Log',
    choose_title: 'Profit-share-Projekt wählen',
    access_count: 'Du hast Zugriff auf {n} Projekt. | Du hast Zugriff auf {n} Projekte.',
    opening_shows: 'Beim Öffnen werden vertrauliche Gehaltsdaten angezeigt.',
    tracklify_projects_count: '{n} Tracklify-Projekt | {n} Tracklify-Projekte',
    members_count: '{n} Mitglied | {n} Mitglieder',
    new_project: 'Neues Projekt',
    landing_kicker: 'Profit-share',
    landing_title: 'Gewinn transparent über deine Projekte teilen',
    landing_text: 'Ein Profit-share-Projekt bündelt Umsatz und erfasste Kosten mehrerer Tracklify-Projekte und verteilt den Rest auf die beteiligten Mitglieder.',
    no_access_yet: 'Du hast noch keinen Zugriff auf ein Profit-share-Projekt.',

    all_participating: 'Alle beteiligten Projekte',
    overview_reveal_hint: 'Sätze und Kosten der Mitglieder bleiben vertraulich, bis eine Mitglied-Monat-Zelle aufgedeckt wird.',
    export_csv: 'CSV ohne Mitglieder exportieren',
    no_operations: 'Noch keine erfassten Vorgänge.',
    rate_missing: 'Satz fehlt',
    vs_six_months: '{change} ggü. vor 6 Mon.',
    carry_over: '({amount} Übertrag)',
    reveal_rate: 'Satz aufdecken',
    reveal_rate_aria: 'Satz von {member} für {month} aufdecken',
    rate_line: 'Satz {rate}',
    mentor_line: '+ Mentor {rate}',
    no_effective_rate: 'Kein gültiger Satz',
    projects_loaded: '{n} Projekt geladen | {n} Projekte geladen',
    load_details: 'Projekt „{name}“ in {seconds} s geladen · Aggregationsabfrage {query} s',
    loading_operations: 'Projektvorgänge werden geladen…',
    no_participating_selected: 'Keine beteiligten Projekte ausgewählt.',
    add_revenue: 'Umsatz hinzufügen',
    revenue: 'Umsatz',
    latest: 'Neueste',
    no_description: 'Keine Beschreibung',
    rate_not_set: 'Kein Satz festgelegt',
    delete_revenue_confirm: 'Diesen Umsatz löschen?',
    delete_revenue: 'Umsatz löschen',
    no_revenue: 'Noch kein Umsatz',
    no_revenue_hint: 'Der Gewinn bleibt negativ, bis Umsatz hinzugefügt wird.',
    update_revenue: 'Umsatz aktualisieren',
    revenue_invalid: 'Betrag und Satz müssen positive Zahlen sein, z. B. 1200.50',
    col_month: 'Monat',
    col_total_spend: 'Gesamtkosten',
    col_rate_efficiency: 'Satzeffizienz',
    col_monthly_profit: 'Monatsgewinn',
    col_distributable_profit: 'Verteilbarer Gewinn',
    col_accumulated_profit: 'Kumulierter Gewinn',

    tracklify_project: 'Tracklify-Projekt',
    rate_per_hour: 'Satz ({currency}/h)',
    amount: 'Betrag',
    currency: 'Währung',
    date: 'Datum',
    sold_hours: 'Verkaufte Stunden',
    note: 'Notiz',
    note_placeholder: 'z. B. Rechnung September',

    member_rates_title: 'Gehaltssätze der Mitglieder',
    rates_hint: 'Eine Aktualisierung pro Mitglied und Monat. Ein Satz gilt, bis eine neuere Aktualisierung ihn ersetzt.',
    rates_reveal_hint: 'Sätze bleiben vertraulich, bis eine Mitglied-Monat-Zelle aufgedeckt wird.',
    add_rate_update: 'Satzänderung hinzufügen',
    no_rates_warning: 'Noch keine Sätze. Kosten und Gewinn lassen sich erst berechnen, wenn Mitglieder mit erfasster Zeit einen Satz haben.',
    select_projects_first: 'Wähle beteiligte Projekte mit bestätigten Mitgliedern, bevor du Sätze hinzufügst.',
    no_rate_history: 'Noch kein Satzverlauf.',
    confidential_rate: 'Vertraulicher Satz',
    edit_rate: 'Satz bearbeiten',
    mentor_rate_line: 'Mentor: {rate}',
    hours_not_estimated: 'Stunden nicht geschätzt',
    add_monthly_rate: 'Monatliche Satzänderung hinzufügen',
    add_rate: 'Satz hinzufügen',
    rates_invalid: 'Sätze müssen Zahlen sein, z. B. 25.50',
    member: 'Mitglied',
    search_members: 'Mitglieder suchen',
    no_members_found: 'Keine Mitglieder gefunden',
    month: 'Monat',
    new_rate: 'Neuer Satz',
    mentor_rate: 'Mentorsatz',
    note_optional: 'Notiz (optional)',

    new_ps_project: 'Neues Profit-share-Projekt',
    edit_ps_project: 'Profit-share-Projekt bearbeiten',
    project_name: 'Projektname',
    project_name_placeholder: 'z. B. Agency pool 2026',
    members_access: 'Mitglieder mit vertraulichem Zugriff',
    add_members: 'Workspace-Mitglieder hinzufügen…',
    members_access_hint: 'Sie sehen Gehaltssätze, Kosten, Umsatz und Gewinn.',
    access_list_author_only: 'Die Liste mit vertraulichem Zugriff sieht nur der Projektautor.',
    participating_projects: 'Beteiligte Tracklify-Projekte',
    add_projects: 'Projekte hinzufügen…',
    participating_hint: 'Workspace-Admins verwalten diese Liste. Sätze gelten für alle ausgewählten Projekte.',
    create_project_btn: 'Projekt erstellen',
    save_project: 'Projekt speichern',

    reveal_title: 'Vertraulichen Satz aufdecken?',
    warning: 'Warnung',
    reveal_admin_text: 'Du deckst diesen Satz als Administrator auf, daher wird dieser Versuch nicht im Audit-Log erfasst. Die gleichen Vertraulichkeitspflichten gelten weiterhin.',
    reveal_member_text: 'Wenn du fortfährst, wird dieser Aufdeckungsversuch dauerhaft unter deinem Konto im Audit-Log gespeichert. {member} kann unbegrenzt Informationen über diesen Versuch erhalten. Der Eintrag kann nicht entfernt und diese Aktion nicht rückgängig gemacht werden.',
    confidential_caps: 'VERTRAULICH',
    confidential_text: 'Informationen zu Sätzen sind streng vertraulich und können durch eine Vereinbarung mit dem Mitglied geschützt sein. Mit dem Aufdecken übernimmst du die volle Verantwortung für den Schutz dieser Informationen.',
    revealing: 'Wird aufgedeckt…',
    reveal: 'Aufdecken',

    confidential: 'Vertraulich',
    consent_title: 'Sensible Profit-share-Informationen',
    rule_see_title: 'Was du siehst',
    rule_see_text: 'Dieses Profit-share-Projekt zeigt vertrauliche Gehaltssätze, erfasste Kosten, Umsatz und Gewinn.',
    rule_stop_title: 'Es bleibt bei Ihnen',
    rule_stop_text: 'Jedes Mitglied des Unternehmens hat das Recht, seinen Gehaltssatz, dessen Verlauf und die Gründe dafür vertraulich zu halten. Auch wenn die Transparenz des Profit-share-Modells die Offenlegung gegenüber berechtigten Teilnehmern unvermeidbar macht, muss jede weitere Weitergabe bei der Person enden, die es ansieht.',
    rule_share_title: 'Nicht teilen oder aufzeichnen',
    rule_share_text: 'Du darfst diese Informationen nicht in öffentlichen Quellen, Screenshots, Bildschirmaufnahmen, Nachrichten oder in anderer Form teilen oder aufzeichnen. Die Weitergabe an Unbefugte kann zu deinem Ausschluss aus Profit-share führen. Tracklify macht Screenshots, die bei geöffnetem Profit-share aufgenommen werden, automatisch unscharf.',
    consent_agree: 'Ich verstehe alle Regeln und stimme zu, dass ich aus Profit-share entfernt werden kann, wenn ich vertrauliche Informationen auf irgendeine Weise teile oder aufzeichne.',
    asked_again: 'Auf einem neuen Gerät oder Browser wirst du erneut gefragt.',
    agree_open: 'Zustimmen und öffnen',

    audit_title: 'Audit-Log',
    audit_hint_full: 'Umsatzänderungen, Änderungen von Gehaltssätzen und Aufdeckungen vertraulicher Sätze.',
    audit_hint_limited: 'Umsatzaktivität und deine eigenen Aufdeckungen vertraulicher Sätze.',
    loading_audit: 'Audit-Log wird geladen…',
    no_audit: 'Noch keine Audit-Einträge.',
    page_info: 'Seite {page} von {pages} · {total} Einträge',
    col_time: 'Zeit',
    col_user: 'Benutzer',
    col_entity: 'Objekt',
    col_action: 'Aktion',
    col_diff: 'Änderungen',
    filter_all_full: 'Alle Finanzaktivitäten',
    filter_all_limited: 'Umsatz und meine Aktionen',
    filter_salary: 'Gehaltssätze',
    filter_reveals: 'Satzaufdeckungen',
    filter_my_reveals: 'Meine Satzaufdeckungen',
    entity_salary: 'Gehaltssatz',
    entity_reveal: 'Satzaufdeckung',
  },
  invoices: {
    invoice_basis: 'Rechnungsgrundlage',
    close_invoice_basis: 'Rechnungsgrundlage schließen',
    close: 'Schließen',
    edit_filters: 'Filter bearbeiten',
    projects: 'Projekte',
    include_tags: 'Tags einschließen',
    exclude_tags: 'Tags ausschließen',
    executors: 'Ausführende',
    count_projects: '{n} Projekt | {n} Projekte',
    count_incl_tags: '{n} eingeschl. Tag | {n} eingeschl. Tags',
    count_excl_tags: '{n} ausgeschl. Tag | {n} ausgeschl. Tags',
    count_executors: '{n} Ausführender | {n} Ausführende',
    block_formatting: 'Blockformatierung',
    font_size_value: 'Schriftgröße: {size}',
    font_size: 'Schriftgröße',
    alignment: 'Ausrichtung',
    column_width: 'Spaltenbreite',
    delete_block: 'Block löschen',
    delete_text_cell: 'Diese Textzelle löschen',
    add_row_after: 'Zeile darunter einfügen',
    add_row_after_title: 'Neue Zeile nach dieser einfügen',
    delete_column: 'Spalte löschen',
    delete_column_title: 'Diese Spalte aus der Tabelle löschen',
    confirm_delete: 'Löschen bestätigen?',
    confirm_deletion: 'Löschen bestätigen',
    cancel_deletion: 'Löschen abbrechen',
    yes: 'Ja',
    no: 'Nein',
    font_large: 'Große Schrift (16px)',
    font_medium: 'Mittlere Schrift (14px)',
    font_small: 'Kleine Schrift (12px)',
    font_extra_small: 'Sehr kleine Schrift (10px)',
    align_left: 'Linksbündig',
    align_center: 'Zentriert',
    align_right: 'Rechtsbündig',
    equal_width_columns: 'Spalten gleicher Breite',
    dynamic_width_columns: 'Spalten dynamischer Breite',
    invoice_generator: 'Rechnungsgenerator',
    invoice_layout: 'Rechnungslayout',
    add_section: 'Abschnitt hinzufügen',
    add_text_section: 'Textabschnitt hinzufügen',
    add_table_section: 'Tabellenabschnitt hinzufügen',
    add_block_right: 'Block rechts hinzufügen',
    add_column_right: 'Spalte rechts hinzufügen',
    empty_block: 'Leerer Block',
    new_row_col: 'Neue Zeile {row}, Spalte {col}',
    new_column: 'Neue Spalte {n}',
    delete_table: 'Tabelle löschen',
    delete_row: 'Zeile löschen',
    delete_table_title: 'Die gesamte Tabelle löschen',
    delete_row_title: 'Diese Zeile aus der Tabelle löschen',
    invoice_preview: 'Rechnungsvorschau',
    download: 'Herunterladen',
    generating_pdf: 'PDF wird erstellt…',
    opening_pdf_preview: 'PDF-Vorschau wird geöffnet…',
    page_of: 'Seite {current} von {total}',
    pdf_generation_failed: 'PDF-Erstellung fehlgeschlagen',
    pdf_generation_error: 'Beim Erstellen der PDF-Vorschau ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    retry: 'Erneut versuchen',
    saving: 'Wird gespeichert…',
    saved: 'Gespeichert',
    choose_template: 'Rechnungsvorlage auswählen',
    choose_template_description: 'Wähle eine gespeicherte Vorlage, um eine Rechnung für die gefilterten Aufgaben zu erstellen, oder beginne eine neue von Grund auf.',
    your_templates: 'Deine Vorlagen',
    legacy_badge: 'LEGACY',
    shared_badge: 'GETEILT',
    created_date: 'Erstellt {date}',
    created_colon_date: 'Erstellt: {date}',
    last_pdf: 'Letztes PDF: {date}',
    never_capital: 'Nie',
    never: 'nie',
    or: 'oder',
    create_new_template: 'Neue Vorlage erstellen',
    template_name: 'Vorlagenname',
    save_name: 'Name speichern',
    cancel_renaming: 'Umbenennen abbrechen',
    name_cant_be_empty: 'Der Name darf nicht leer sein',
    rename_hint: 'Enter zum Speichern · Esc zum Abbrechen',
    duplicate_name: '{name} duplizieren',
    duplicate: 'Duplizieren',
    rename_name: '{name} umbenennen',
    rename: 'Umbenennen',
    delete_name: '{name} löschen',
    delete: 'Löschen',
    templates: 'Vorlagen',
    find_template_placeholder: 'Vorlage suchen…',
    find_template: 'Vorlage suchen',
    no_templates_match: 'Keine Vorlagen für „{query}“',
    new_template: 'Neue Vorlage',
    pinned: 'Angeheftet',
    pinned_title: 'Angeheftete Systemvariable, immer vorhanden',
    auto: 'Auto',
    about_name: 'Über {name}',
    edit_name_description: 'Beschreibung von {name} bearbeiten',
    edit_description: 'Beschreibung bearbeiten',
    unlock_name_value: 'Wert von {name} entsperren',
    lock_name_value: 'Wert von {name} sperren',
    unlock_variable: 'Variable entsperren',
    lock_variable: 'Variable sperren',
    enter_variable_description: 'Variablenbeschreibung eingeben',
    available_variables: 'Verfügbare Variablen',
    current_value: 'Aktueller Wert',
    no_variables_found: 'Keine Variablen ähnlich „{query}“ gefunden',
    error_badge: 'FEHLER',
    template_and_basis: 'Vorlage und Rechnungsgrundlage',
    reset: 'Zurücksetzen',
    unshare_template: 'Freigabe der Vorlage für den Workspace aufheben',
    shared_click_to_unshare: 'Für den Workspace freigegeben. Klicken, um die Freigabe aufzuheben',
    save_and_share_confirm: 'Vorlage speichern und für den Workspace freigeben? Workspace-Mitglieder sehen deine Vorlage und Variablen (nur Lesezugriff).',
    share_confirm: 'Vorlage für den Workspace freigeben? Workspace-Mitglieder sehen deine Vorlage und Variablen (nur Lesezugriff).',
    share_template: 'Vorlage für den Workspace freigeben',
    share: 'Freigeben',
    legacy_template_notice: 'Dies ist eine Legacy-Vorlage. Sie kann hier nicht bearbeitet werden, aber ihr HTML kann heruntergeladen werden.',
    download_legacy_html: 'Legacy-HTML herunterladen',
    template_variables: 'Vorlagenvariablen',
    template_owner: 'Vorlageninhaber',
    unknown_user: 'Unbekannter Benutzer',
    current_marker: '(Aktuell)',
    save_and_generate: 'Speichern und erstellen',
    generate: 'Erstellen',
    delete_template_confirm: 'Möchtest du diese Vorlage wirklich löschen?',
    unsaved_leave_message: 'Änderungen an dieser Vorlage speichern, bevor du sie verlässt?',
    keep_editing: 'Weiter bearbeiten',
    untitled_template: 'Unbenannte Vorlage',
    template_copy_name: '{name} (Kopie)',
  },
  salary: {
    salary_projects_breadcrumb: 'Gehaltsprojekte /',
    select_salary_project: 'Gehaltsprojekt auswählen',
    generates_monthly_on_day: 'Wird monatlich am Tag {day} erstellt',
    generates_weekly_on_day: 'Wird wöchentlich am Tag {day} erstellt',
    recalculating_results: 'Ergebnisse werden neu berechnet..',
    create_salary_project: 'Gehaltsprojekt erstellen',
    edit_salary_project: 'Gehaltsprojekt bearbeiten',
    confirm_delete_project: 'Möchtest du dieses Gehaltsprojekt wirklich löschen?',
    delete: 'Löschen',
    no_projects_yet: 'Noch keine Gehaltsprojekte. Erstelle eines, um zu starten.',
    current_period_not_settled: 'Aktuell · {progress} · nicht abgerechnet',
    day_progress: 'Tag {day} von {total}',
    members_count: '{n} Mitglied | {n} Mitglieder',
    across_members: 'über {n} Mitglied | über {n} Mitglieder',
    add_member: 'Mitglied hinzufügen',
    search_members: 'Mitglieder suchen',
    add_member_to_current_period: 'Mitglied zum aktuellen Zeitraum hinzufügen',
    member: 'Mitglied',
    user_vars: 'Benutzervariablen',
    calculated: 'Berechnet',
    export_column_csv: 'Diese Spalte als CSV exportieren',
    confirm_remove_member: 'Dieses Mitglied aus dem aktuellen Zeitraum entfernen?',
    remove_member: 'Mitglied entfernen',
    summary: 'Zusammenfassung',
    columns_count: '{shown} von {total} Spalten',
    metric_min: 'min',
    metric_avg: 'Ø',
    metric_max: 'max',
    metric_median: 'Median',
    metric_sum: 'Summe',
    show_min: 'Min anzeigen',
    show_avg: 'Durchschnitt anzeigen',
    show_max: 'Max anzeigen',
    show_median: 'Median anzeigen',
    show_sum: 'Summe anzeigen',
    select_project_from_list: 'Wähle ein Gehaltsprojekt aus der Liste oben.',
    popup_subtitle: 'Gehälter werden automatisch nach Zeitplan erstellt.',
    project_name: 'Projektname',
    project_name_placeholder: 'z. B. Team Kyjiw',
    frequency: 'Häufigkeit',
    week: 'Woche',
    month: 'Monat',
    day_of_month: 'Tag des Monats',
    day_of_week: 'Wochentag',
    of_max_day: 'von {max}',
    timezone: 'Zeitzone',
    select_timezone: 'Zeitzone auswählen',
    recreate_to_change_settings: '(um die obigen Einstellungen zu ändern, erstelle das Projekt neu)',
    variables: 'Variablen',
    add_variable: 'Variable hinzufügen',
    no_variables_yet: 'Noch keine Variablen. Füge Werte pro Mitglied hinzu, z. B. Grundgehalt oder Stundensatz.',
    move_up: 'Nach oben',
    move_down: 'Nach unten',
    create_project: 'Projekt erstellen',
    average_salary: 'Durchschnittsgehalt',
    total_hours: 'Stunden gesamt',
    predicted_salary: 'Prognostiziertes Gehalt',
    actually_earned: 'Tatsächlich verdient',
    own_hours: 'Eigene Stunden',
    end_of_month_forecast: 'Prognose zum Monatsende',
    base_percent_hint: 'Basis {base} · {percent}% der Basis',
    incl_base_in_eur: 'inkl. Basisgehalt · in EUR',
    at_rate_per_hour: 'bei {rate}/h',
    not_receiving_salary_yet: 'du erhältst in diesem Projekt noch kein Gehalt',
    var_desc_user_time_spent: 'Erfasste Zeit des Benutzers (Stunden) im Zeitraum; optional 3. Argument = E-Mail, 4. Argument = Projektname',
    var_desc_user_prediction_median: 'Median von USER_TIME_SPENT über die letzten N Zeiträume (Stunden); optionale Filter für E-Mail/Projekt',
    var_desc_min: 'Gibt den kleineren von zwei numerischen Werten zurück',
    var_desc_previous_salary_point: 'Saldo des vorherigen Gehaltseintrags',
    var_desc_user_vars: 'Eigene Benutzervariable (var_name durch deinen Schlüssel ersetzen)',
    var_desc_exchange_rate: 'Wechselkurs {alias}',
    var_desc_exchange_rate_month_start: 'NBU-Kurs am 1. Tag des Periodenmonats (USD-UAH, EUR-UAH, PLN-UAH, CAD-UAH)',
    var_desc_previously_defined: 'Zuvor definierte Variable',
    csv_copied: 'CSV in die Zwischenablage kopiert',
    csv_copy_failed: 'CSV konnte nicht kopiert werden. Bitte versuche es erneut.',
  },
  tags: {
    burned_hours: 'Verbrauchte Stunden',
    planned: 'Geplant',
    passed: 'Erledigt',
    est_h: 'Schätz. h',
    tracked: 'Erfasst',
    burned: 'Verbraucht',
    avg_velocity: 'Ø Velocity',
    before_sprint: 'Vor dem Sprint',
    during_sprint: 'Während des Sprints',
    all_projects: 'Alle Projekte',
    all_sprint_tasks: 'Alle Sprint-Aufgaben',
    non_own_sprint_tasks: 'Fremde Sprint-Aufgaben',
    non_this_project: 'Andere Projekte',
    effort_change: 'Aufwandsänderung',
    native_level: 'Projektanteil',
    altruist: 'Altruismus',
    sprint_start: 'Sprintbeginn',
    weekends_per_week: 'Wochenendtage / Woche',
    days_in_sprint: 'Tage im Sprint',
    show_velocity_stats: 'Velocity-Statistik anzeigen',
    show_main_stats: 'Hauptstatistik anzeigen',
    burndown: 'Burndown',
    remaining_vs_ideal_pace: 'Verbleibende Stunden vs. ideales Tempo',
    remaining: 'Verbleibend',
    ideal: 'Ideal',
    remaining_hours: 'Verbleibende Stunden',
    ideal_burndown: 'Idealer Burndown',
    tag_focus_hotkey: 'Tag-Fokus (Alt+G)',
    tag_focus: 'Tag-Fokus',
    unfocus: 'Fokus aufheben',
    filter_tags: 'Tags filtern...',
    show_eta: 'ETA anzeigen',
    calculate_eta: 'ETA berechnen',
    export_settings: 'Exporteinstellungen',
    include_executor: 'Ausführenden einbeziehen',
    hours_in_story_point: 'Stunden pro Story Point',
    round_up_to: 'Aufrunden auf',
    include_doing_hint: 'Ob eine Doing-Spalte hinzugefügt werden soll, damit der Kunde Einträge per Checkbox aktivieren/deaktivieren kann',
    include_doing: 'Doing einbeziehen',
    notdoing_tag: 'Notdoing-Tag',
    select_label: 'Label auswählen',
  },
  pages: {
    access_denied_title: 'Es tut uns leid',
    access_denied_subtitle: 'Etwas ist schiefgelaufen und du wurdest von deinem aktiven Workspace abgemeldet.',
    access_denied_select_workspace: 'Wähle einen Workspace, um fortzufahren',
    access_denied_no_workspaces: 'Du hast noch keine verfügbaren Workspaces.',
    access_denied_create_new: 'Neuen erstellen',
    access_denied_logged_in_as: 'Angemeldet als {email}',
    access_denied_login_another: 'Mit einem anderen Konto anmelden',
    ai_automation_other_client: 'Andere',
    app_download_not_uploaded: 'Nicht hochgeladen',
    mcp_authorize_title: '{client} verbinden?',
    mcp_authorize_acts_on_behalf: '{client} ({host}) möchte im Workspace {workspace} in deinem Namen handeln: Es kann alles sehen und ändern, was du kannst.',
    mcp_authorize_loopback_warning: 'Nach deiner Antwort kehrt dein Browser zu einer App zurück, die auf diesem Computer läuft. Erlaube dies nur, wenn du gerade selbst begonnen hast, {client} zu verbinden.',
    mcp_authorize_redirect_notice: 'Nach deiner Antwort kehrt dein Browser zu {host} zurück.',
    mcp_authorize_deny: 'Ablehnen',
    mcp_authorize_allow: 'Erlauben',
    mcp_authorize_invalid: 'Diese Autorisierungsanfrage ist ungültig oder abgelaufen. Starte die Verbindung erneut in deinem MCP-Client.',
    project_no_projects_title: 'Du hast noch keine Projekte 👀',
    project_no_projects_hint: 'Bitte {create_project} im Menü oben links, indem du auf {no_projects} klickst',
    project_create_project: 'erstelle ein Projekt',
    project_no_projects: 'Keine Projekte',
    project_settings_loading: 'Wird geladen...',
    integrations_add: 'Integration hinzufügen',
    integrations_added_by: 'Hinzugefügt von {name} · {date}',
    integrations_unknown_user: 'Unbekannt',
    integrations_close_config: 'Konfiguration schließen',
    integrations_config: 'Konfiguration',
    integrations_delete_confirm: 'Diese Integration löschen?',
    integrations_default_description: '{name}-Integration',
    downtime_snooze_title: 'Für 10 Minuten schlummern',
    task_notify_priority_title: 'Priorität: {priority}',
    report_export_preparing: 'Wird vorbereitet…',
  },
  ui: {
    ai_chat_empty: 'Bitte mich, deine Projekte aufzulisten oder Aufgaben zu erstellen.',
    ai_chat_error: 'Fehler: {error}',
    ai_chat_openai_auth_error: 'KI-Assistent nicht verfügbar: Der OpenAI-API-Schlüssel ist ungültig oder abgelaufen.',
    ai_chat_something_went_wrong: 'Etwas ist schiefgelaufen',
    checklist_progress_title: 'Checklisten-Fortschritt: {done} von {total} erledigt',
    close_button_title: 'Schließen [ESC]',
    comment_integration: 'Integration',
    comment_unknown_user: 'Unbekannt',
    common_header_create_task_title: 'Aufgabe erstellen [Alt+N]',
    create_task_error_reading_file: 'Fehler beim Lesen der Datei. Bitte versuche es erneut.',
    download_mobile_back: 'Zurück',
    download_mobile_install_app: 'App installieren',
    editor_sign_up_not_confirmed: 'Registrierung nicht bestätigt',
    header_hidden_members: 'Das Projekt hat {count} weitere Mitglieder:',
    hidden_screenshot_tooltip_in_project: 'Du kannst diesen Screenshot nicht ansehen, da du kein Mitglied des Projekts {projectName} bist',
    hidden_screenshot_tooltip_no_project: 'Du kannst diesen Screenshot nicht ansehen, da du kein Mitglied dieses Projekts bist',
    hidden_task_tooltip_in_project: 'Du kannst diese Aufgabe nicht ansehen, da du kein Mitglied des Projekts {projectName} bist',
    hidden_task_tooltip_no_project: 'Du kannst diese Aufgabe nicht ansehen, da du kein Mitglied dieses Projekts bist',
    integration_bot_name: 'Name',
    integration_bot_title: 'Bot',
    integration_param_readonly: 'schreibgeschützt',
    pager_try_again_later: 'Bitte versuche es später erneut',
    recording_controls_microphone_level: 'Mikrofonpegel',
    recording_controls_pause_title: 'Bildschirmaufnahme pausieren',
    recording_controls_resume_title: 'Bildschirmaufnahme fortsetzen',
    recording_controls_stop_title: 'Bildschirmaufnahme beenden',
    searcher_no_tags: 'keine Tags',
    searcher_with_tag: 'Mit Tag:',
    spinner_loading: 'Wird geladen...',
    stage_enter_new_name: 'Der Name der Phase darf nicht leer sein',
    stage_no_name: 'Phase ohne Namen',
    task_click_to_assign: 'Zum Zuweisen klicken',
    task_dialog_comments_only: 'Nur Kommentare',
    task_dialog_drop: 'Hier ablegen',
    task_dialog_logs_shown: 'Protokolle sichtbar',
    task_dialog_parent_task: 'Übergeordnete Aufgabe',
    task_dialog_return_to_parent: 'Zurück zur übergeordneten Aufgabe',
    task_dialog_scroll_to_top: 'Nach oben scrollen',
    task_dialog_subtasks: 'Unteraufgaben',
    task_dialog_subtasks_caption: 'UNTERAUFGABEN',
    task_dialog_toggle_rightbar: 'Aufgabendetails',
    task_right_bar_add_subtask_title: 'Unteraufgabe hinzufügen [Alt+Ctrl+N]',
    user_avatar_executor_title: '{username} ist Ausführender dieser Aufgabe',
  },
};
